import { TeaserProps, AdProps, ComponentType, AdPlacementType } from '@sport1/types/web'
import { SizeTypes } from '@/types/size'

export const adjustTeasers = (
    teaser: (TeaserProps | AdProps)[],
    hasRightColumn?: boolean,
    currentDevice?: SizeTypes
) => {
    const teaserAd = teaser.find(
        item => item.type === ComponentType.AD && item.ad?.placement === AdPlacementType.TEASER
    ) as TeaserProps

    const maxAmountOfTeasersForDesktop = hasRightColumn ? [1, 2, 3, 5, 7, 9] : [1, 2, 3, 4, 7, 10]
    const maxAmountOfTeasersForTablet = [1, 2, 3, 5, 7, 9]
    const maxAmountOfTeasers =
        currentDevice === SizeTypes.TABLET
            ? maxAmountOfTeasersForTablet
            : maxAmountOfTeasersForDesktop

    const tempTeasers = teaser.filter(item => item.type !== ComponentType.AD)
    const contentLength = tempTeasers?.length + (teaserAd ? 1 : 0)
    const validLength = maxAmountOfTeasers.findLast(n => n <= contentLength) ?? 0
    const adjustedTeasers = tempTeasers.slice(0, validLength)

    if (teaserAd) {
        if (validLength > adjustedTeasers.length) {
            adjustedTeasers.push(teaserAd)
        } else {
            adjustedTeasers[adjustedTeasers.length - 1] = teaserAd
        }
    }

    return adjustedTeasers
}
